(function () {
  'use strict';

  function initHero(hero) {
    if (!hero || hero.dataset.rouxHeroReady === 'true') return;
    hero.dataset.rouxHeroReady = 'true';

    if (!hero.classList.contains('roux-hero--reveal')) {
      hero.classList.add('is-visible');
      return;
    }

    if (!('IntersectionObserver' in window)) {
      hero.classList.add('is-visible');
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        hero.classList.add('is-visible');
        observer.unobserve(hero);
      });
    }, {
      threshold: 0.12
    });

    observer.observe(hero);
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-roux-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();